import { useSelector } from 'hooks/redux';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';
import { RootState } from '../../../types';
import ProfileUserForm from './form';

const ProfileUser = () => {
  const profile = useSelector((state: RootState) => state.auth.profile);

  return (
    <AppPageMain>
      <div className="container profile-company">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                {
                  link: '',
                  title: profile?.firstName + ' ' + profile?.lastName,
                },
              ]}
              isHideBalanceInformer={profile.position === 'OPERATOR'}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <ProfileUserForm />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default ProfileUser;
